import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { UitkFigure, UitkImage } from 'uitk-react-images';

import { Lazy } from 'components/common/lazy/lazy';

export interface LazyImageProps {
  experimentName?: string;
  altPlaceholderText?: string;
  className?: string;
}
export const LazyImage: React.FC<LazyImageProps> = ({ experimentName, children, className, altPlaceholderText }) => {
  const lazyImage = (
    <Lazy className={className}>
      <Lazy.Placeholder>
        <UitkFigure>
          <UitkImage alt={altPlaceholderText} placeholderImage={true} />
        </UitkFigure>
      </Lazy.Placeholder>
      <Lazy.Loaded>{children}</Lazy.Loaded>
    </Lazy>
  );

  if (!experimentName) {
    return lazyImage;
  }

  return (
    <AbacusExperiment name={experimentName}>
      <AbacusControl>{children}</AbacusControl>
      <AbacusVariant bucket={1}>{lazyImage}</AbacusVariant>
    </AbacusExperiment>
  );
};
